import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

// ─── Navigation data ──────────────────────────────────────────────────────────
const FOOTER_SECTIONS = [
  {
    heading: "COMPETITIONS",
    links: [
      { label: "How to Play",          to: "/how_to_play" },
      { label: "Match Predictor Rules", to: "/rules" },
      { label: "Golf Rules",            to: "/golf-rules" },
    ],
  },
  {
    heading: "POLICIES",
    links: [
      { label: "Privacy Policy",        to: "/privacy_policy" },
      { label: "Cookie Policy",         to: "/cookie-policy" },
      { label: "Terms & Conditions",    to: "/terms_conditions" },
    ],
  },
  {
    heading: "SUPPORT",
    links: [
      { label: "FAQs",                  to: "/faqs" },
      { label: "Feedback",              to: "/feedback" },
      { label: "Contact Us",            to: "/contact_us" },
    ],
  },
  {
    heading: "RESPONSIBLE GAMING",
    links: [
      { label: "Safer Gambling",        to: "/safer_gambling" },
    ],
  },
];

// ─── Component ────────────────────────────────────────────────────────────────
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="tp-footer">
      {/* Four-column nav grid */}
      <div className="tp-footer__grid">
        {FOOTER_SECTIONS.map((section) => (
          <div key={section.heading}>
            <h3 className="tp-footer__heading">{section.heading}</h3>
            <ul className="tp-footer__links">
              {section.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Logos row */}
      <div className="tp-footer__logos" style={{ display: "none" }}>
        <div className="tp-footer__gambling-logos">
          <img src="/images/18plus.png"        alt="18+" />
          <img src="/images/gambleaware.png"   alt="GambleAware" />
        </div>
      </div>

      {/* Copyright */}
      <div className="tp-footer__copyright">
        © {year} TPG Technology Ltd. ALL RIGHTS RESERVED.
      </div>
    </footer>
  );
};

export default Footer;
